import * as tslib_1 from "tslib";
import * as domain from '../actions/domain.actions';
import { createSelector } from '@ngrx/store';
import { DomainActionTypes } from '../actions/domain.actions';
var initialState = {
    domains: [],
    currentDomain: null,
    errorMessage: null,
    loading: []
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case domain.DomainActionTypes.LOAD_DOMAIN_LIST: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case domain.DomainActionTypes.LOAD_DOMAIN_LIST_SUCCESS: {
            return tslib_1.__assign({}, state, { domains: action.payload, loading: clearLoading(state, DomainActionTypes.LOAD_DOMAIN_LIST), errorMessage: null });
        }
        case domain.DomainActionTypes.LOAD_DOMAIN_LIST_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, DomainActionTypes.LOAD_DOMAIN_LIST), errorMessage: action.payload });
        }
        case domain.DomainActionTypes.CLEAR_LOAD_DOMAIN_LIST: {
            localStorage.setItem('domain', '{ domains: [], currentDomain: null, errorMessage: null }');
            return tslib_1.__assign({}, state, { domains: [], currentDomain: null, loading: clearLoading(state, DomainActionTypes.LOAD_DOMAIN_LIST), errorMessage: null });
        }
        case domain.DomainActionTypes.SET_DOMAIN: {
            return tslib_1.__assign({}, state, { currentDomain: action.payload, loading: state.loading.concat([action.type]) });
        }
        case domain.DomainActionTypes.CHANGE_DOMAIN: {
            return tslib_1.__assign({}, state, { currentDomain: action.payload, loading: state.loading.concat([action.type]) });
        }
        case domain.DomainActionTypes.CREATE_DOMAIN_SUCCESS: {
            return tslib_1.__assign({}, state, { domains: state.domains.concat([action.payload]), loading: clearLoading(state, DomainActionTypes.CREATE_DOMAIN) });
        }
        case domain.DomainActionTypes.CREATE_DOMAIN_FAILURE: {
            return tslib_1.__assign({}, state, { errorMessage: action.payload, loading: clearLoading(state, DomainActionTypes.CREATE_DOMAIN) });
        }
        default: {
            return state;
        }
    }
}
var domainSelector = function (state) { return state.domain; };
var ɵ0 = domainSelector;
var ɵ1 = function (state) { return state.domains; }, ɵ2 = function (state) { return state.currentDomain; }, ɵ3 = function (state) { return state.loading; };
export var Selectors = {
    getDomains: createSelector(domainSelector, ɵ1),
    getCurrentDomain: createSelector(domainSelector, ɵ2),
    getLoading: createSelector(domainSelector, ɵ3)
};
function clearLoading(authState, action) {
    return authState.loading.filter(function (loadingMarker) { return loadingMarker !== action; });
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
